module.exports = __webpack_public_path__ + "img/Russian.ff111d74.svg";